// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* alternatebootstrap.css
   Loads the original react-phone-input-2 bootstrap theme,
   but removes the bootstrap blue focus rings.
*/

/* If this path is different in your project, adjust it */
/*@import url("./bootstrap.css");*/

/* --- kill the input blue ring --- */
.react-tel-input .form-control:focus,
.react-tel-input .form-control:focus-visible {
  border-color: inherit !important; /* or #000 if you prefer */
  box-shadow: none !important;
  outline: none !important;
}

/* --- kill the flag button blue ring (this is the big offender) --- */
.react-tel-input .selected-flag:focus:before,
.react-tel-input .selected-flag:focus-visible:before,
.react-tel-input .selected-flag.open:before {
  border-color: transparent !important;
  box-shadow: none !important;
}

/* optional: also prevent any outline on the clickable flag area */
.react-tel-input .flag-dropdown:focus,
.react-tel-input .flag-dropdown:focus-visible,
.react-tel-input .selected-flag:focus,
.react-tel-input .selected-flag:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/alternatebootstrap.css"],"names":[],"mappings":"AAAA;;;CAGC;;AAED,yDAAyD;AACzD,kCAAkC;;AAElC,qCAAqC;AACrC;;EAEE,gCAAgC,EAAE,0BAA0B;EAC5D,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA,sEAAsE;AACtE;;;EAGE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,kEAAkE;AAClE;;;;EAIE,wBAAwB;EACxB,2BAA2B;AAC7B","sourcesContent":["/* alternatebootstrap.css\n   Loads the original react-phone-input-2 bootstrap theme,\n   but removes the bootstrap blue focus rings.\n*/\n\n/* If this path is different in your project, adjust it */\n/*@import url(\"./bootstrap.css\");*/\n\n/* --- kill the input blue ring --- */\n.react-tel-input .form-control:focus,\n.react-tel-input .form-control:focus-visible {\n  border-color: inherit !important; /* or #000 if you prefer */\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n/* --- kill the flag button blue ring (this is the big offender) --- */\n.react-tel-input .selected-flag:focus:before,\n.react-tel-input .selected-flag:focus-visible:before,\n.react-tel-input .selected-flag.open:before {\n  border-color: transparent !important;\n  box-shadow: none !important;\n}\n\n/* optional: also prevent any outline on the clickable flag area */\n.react-tel-input .flag-dropdown:focus,\n.react-tel-input .flag-dropdown:focus-visible,\n.react-tel-input .selected-flag:focus,\n.react-tel-input .selected-flag:focus-visible {\n  outline: none !important;\n  box-shadow: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
